// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d5cee45","952":"903ab474"}[chunkId] + ".chunk.js";
};